module.exports = __webpack_public_path__ + "img/page7img3.06ca977e.png";